export interface MtPaymentsPageProps {}
